import { useSelector } from 'react-redux';

import { IEditingState, ModeTypes, selectEditingState } from './editingSlice';

export const useEditingState = (): IEditingState => useSelector(selectEditingState);
export const useMode = (): ModeTypes => useSelector(selectEditingState).mode;
